import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/laptopDashboard.webp'

export const LaptopDashboard: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'laptop'} />
)
